import { render, staticRenderFns } from "./Digital-Renovation-New-Request-Step2.vue?vue&type=template&id=1965a3be&scoped=true&"
import script from "./Digital-Renovation-New-Request-Step2.vue?vue&type=script&lang=js&"
export * from "./Digital-Renovation-New-Request-Step2.vue?vue&type=script&lang=js&"
import style0 from "./Digital-Renovation-New-Request-Step2.vue?vue&type=style&index=0&id=1965a3be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1965a3be",
  null
  
)

export default component.exports